import styled from "styled-components";
import breakpoints from "../../constants/breakpoints";
export const Styles = styled.div`
  position: relative;
  
  background: ${(props) =>
    props.backgroundColor ||
    "linear-gradient(180deg, #4f6f74 0%, #1a3540 100%)"};
  color: #e6f0f2;
  overflow: hidden;
  clip-path: polygon(0 12%, 100% 1%, 100% 100%, 0% 100%);
  .footer-inner {
    position: relative;
    .footer-main {
      display: flex;
      align-items: flex-start;
      padding: 100px 0 42px;
    }

    .footer-columns {
      justify-content: space-between;
    }

    .footer-col {
      h4 {
        font-size: var(--font-size-medium);
        font-weight: 600;
        margin-bottom: 10px;
        color: #f4fbfc;
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        display: grid;
        gap: 6px;
      }

      a {
        color: #d5e4e8;
        text-decoration: none;
        font-size: var(--font-size);

        &:hover {
          color: #ffffff;
        }
      }
    }

    .footer-brand {
      text-align: start;
      min-width: 220px;
    }

    .footer-logo {
      width: 150px;
      height: auto;
      margin-bottom: 8px;
      object-fit: contain;
      filter: invert(100%) sepia(45%) saturate(2%) hue-rotate(6deg) brightness(305%) contrast(100%);
    }

    .footer-tagline {
      margin: 0 0 14px;
      color: #dbe9ed;
      font-size: var(--font-size);
      font-weight: 600;
      text-align: start;
    }

    .footer-social {
      display: flex;
      gap: 10px;
      justify-content: flex-start;
    }

    .footer-bottom {
      border-top: 1px solid rgba(255, 255, 255, 0.18);
      display: flex;
      justify-content: space-between;
      color: #d6e3e6;
      font-size: var(--font-size);
      min-height: 60px;
      align-items: center;
      position: relative;
      .engrave-image {
        position: absolute;
        top: -35px;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .footer-author {
      color: #7ad1e4;
      font-weight: 600;
    }
  }

  @media (max-width: ${breakpoints.lg}) {
    .footer-main {
      flex-direction: column;
      align-items: stretch;
    }

    .footer-brand {
      text-align: left;
    }

    .footer-social {
      justify-content: flex-start;
    }
  }

  @media (max-width: ${breakpoints.md}) {
    
    .footer-inner {
      padding: 40px 24px 20px;
    }

    .footer-columns {
      grid-template-columns: repeat(2, minmax(140px, 1fr));
      gap: 24px;
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    .footer-columns {
      grid-template-columns: 1fr;
    }

    .footer-bottom {
      flex-direction: column;
      text-align: center;
      align-items: center;
    }
  }
`;
